<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" class="viewProducts">
            <div class="mb-20">
<!--                <el-button size="small" type="primary" @click="serchInfo">-->
<!--                    搜索-->
<!--                </el-button>-->
                <el-button @click="submit" size="small" type="primary">下载源文件</el-button>
                <el-button @click="downLoadKeeps" size="small" type="primary">下载存档文件</el-button>
                <el-button @click="downLoadFloors" size="small" type="primary">下载底板文件</el-button>
                <el-button @click="downLoadPanels" size="small" type="primary">下载面板文件</el-button>
                <el-button @click="downLoadManuscripts" size="small" type="primary">下载字稿文件</el-button>
                <el-button @click="sendingToManuscripts" size="small" type="success">发送至字稿拼版</el-button>
            </div>
            <div style="margin: 10px">
                <el-table
                    :data="tableData"
                    stripe
                    border
                    ref="tableData"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"

                >
                    <el-table-column
                        type="selection"
                        align="center"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        prop="category"
                        align="center"
                        label="产品名称"
                    ></el-table-column>
                    <el-table-column
                        prop="num"
                        align="center"
                        label="数量"
                    ></el-table-column>
                    <el-table-column
                        prop="listPrice"
                        align="center"
                        label="单价"
                    ></el-table-column>
                    <el-table-column
                        prop="subclass"
                        align="center"
                        label="产品类别"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        prop="thumbnailPath"
                        label="缩略图"
                        align="center"
                        width="200">
                        <template slot-scope="scope">
                            <el-popover placement="top-start" trigger="click">
                                <!--trigger属性值：hover、click、focus 和 manual-->
                                <a :href="scope.row.thumbnailPath" target="_blank" title="查看最大化图片">
                                    <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
                                </a>
                                <img slot="reference" :src="scope.row.thumbnailPath"
                                     style="max-height: 50px;max-width: 50px;cursor:pointer">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="processRequirements"
                        align="center"
                        label="工艺要求"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        prop="remarks"
                        align="center"
                        label="备注"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        prop="createTime"
                        align="center"
                        label="上传时间"
                        width="180"
                    ></el-table-column>



                    <!--                        <el-table-column-->
                    <!--                            prop="number"-->
                    <!--                            align="center"-->
                    <!--                            label="产品编号"-->
                    <!--                            width="180"-->
                    <!--                        ></el-table-column>-->
                    <el-table-column
                        prop="unit"
                        align="center"
                        label="单位"
                    ></el-table-column>
                    <el-table-column
                        prop="specifications"
                        align="center"
                        label="规格"
                    ></el-table-column>
                </el-table>
            </div>
<!--            <div class="pagination">-->
<!--                <el-pagination-->
<!--                    :current-page="currentPage"-->
<!--                    :page-sizes="[10, 30, 50, 100]"-->
<!--                    :page-size="pageSize"-->
<!--                    layout="total, sizes, prev, pager, next, jumper"-->
<!--                    :total="total"-->
<!--                    @size-change="handleSizeChange"-->
<!--                    @current-change="handleCurrentChange"-->
<!--                ></el-pagination>-->
<!--            </div>-->
        </el-dialog>
    </div>
</template>

<script>
import {selectOrderInfo,orderInfoBatchDelete,orderInfoInsertOne ,sendingToManuscripts} from '@/api/order/orderInfo'
export default {
    name: "viewProduct",
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            multipleSelection:[],
            currentPage:1,
            pageSize:10,
            total:0,
        }
    },
    methods: {
        visible(data){
            this.tableData = data
            this.dialogVisible = true
        },
        // handleSizeChange(val) {
        //     this.pageSize = val
        //     this.getTable()
        // },
        // handleCurrentChange(val) {
        //     this.currentPage = val
        //     this.getTable()
        // },
        getTableData() {
            selectOrderInfo(this.currentPage, this.pageSize, this.SelectOrderInformationDTO).then((res) => {
                this.conTract = res.data.data.records
                this.total = Number(res.data.data.total)
            })
        },
        handleEdit(row) {
            this.disabled = true
            this.dialogVisible = true
            this.accountForm = row
            // this.path = row.thumbnailPath
        },
        placeOrder(row) {
            this.dialogVisible = true
            this.accountForm = Object.assign({}, this.$options.data().accountForm);
            this.accountForm.access = localStorage.getItem("access")
            orderInfoInsertOne(this.accountForm).then((res) => {
                this.accountForm.id = res.data.data.id
                this.accountForm.orderNumber = res.data.data.orderNumber
            })
            this.disabled = false
            this.accountForm.orderTime = this.getCurrentTime()
            this.accountForm.deliveryTime = this.getdeliveryTime()
            this.getTable()
        },
        againhandleEdit(row) {
            this.dialogVisible = true
            this.accountForm = row
            this.accountForm.id = ''
            orderInfoInsertOne(this.accountForm).then((res) => {
                this.accountForm.id = res.data.data.id
                this.accountForm.orderNumber = res.data.data.orderNumber
            })
            this.disabled = false
            this.accountForm.orderTime = this.getCurrentTime()
            this.accountForm.deliveryTime = this.getdeliveryTime()
            this.getTable()
        },
        tohandleEdit(row) {
            this.disabled = false
            this.dialogVisible = true
            this.accountForm = row
        },
        getCurrentTime() {
            //获取当前时间并打印
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            _this.gettime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;

            return _this.gettime;
        },
        getdeliveryTime() {
            //获取当前时间并打印
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate() + 1;
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            _this.gettime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
            return _this.gettime;
        },
        sendingToManuscripts(row) {
            sendingToManuscripts(this.multipleSelection).then((res) => {
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        type: "error",
                        message: "sorry,你还没有勾选任何文件呢!"
                    });
                    return;
                }
                if (res.data.code === 10000) {
                    if (res.data.msg === '操作成功') {
                        this.$message({
                            type: 'success',
                            message: '发送字稿拼版成功!',
                        }),
                            this.getTable()

                    } else if (res.data.msg !== '操作成功') {
                        this.$message({
                            type: 'info',
                            message: res.data.data
                        })
                    }
                }
            })

        },
        handleDelete(row) {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    orderInfoBatchDelete(this.multipleSelection).then((res) => {
                        if (res.data.msg === '操作成功') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                            }),
                                this.getTable()

                        } else if (res.data.msg !== '操作成功') {
                            this.$message({
                                type: 'info',
                                message: res.data.data
                            })
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },

        getTable() {
            // selectOrderInfo(this.currentPage, this.pageSize, this.SelectOrderInformationDTO).then((res) => {
            //     this.conTract = res.data.data.records
            //     this.total = Number(res.data.data.total)
            // })
        },
        submit() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoad", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                    this.getTable()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time = this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = orderName + ' ' + time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
        downLoadKeeps() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadKeeps", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                    this.getTable()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time = this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = orderName + ' ' + time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
        downLoadFloors() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadFloors", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                    this.getTable()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time = this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = orderName + ' ' + time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
        downLoadPanels() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadPanels", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                    this.getTable()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time = this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = orderName + ' ' + time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
        downLoadManuscripts() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadManuscripts", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                    this.getTable()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time = this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = orderName + ' ' + time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 将获取到的id存入ids中
        // handleSelect(selection, row){
        //     const isSelect = selection.find(item=>item.id === row.id)
        //     if(isSelect){
        //         this.ids.push(row)
        //     }else{
        //         const index = this.ids.findIndex(item=>item.id === row.id)
        //         this.ids.splice(index,1)
        //     }
        // },
        // handleAllSelect(selection){
        //     if(selection.length){
        //         selection.forEach(item=>{
        //             const flag = this.ids.find(child=>item.id === child.id)
        //             if(!flag) this.ids.push(item)
        //         })
        //     }else{
        //         this.gridData.forEach(item=>{
        //             const index = this.ids.findIndex(child=>child.id === item.id)
        //             this.ids.splice(index,1)
        //         })
        //     }
        // },
    }
}
</script>

<style scoped>
    ::v-deep.viewProducts .el-dialog{
        width: 80%;
    }
</style>
